import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import StepperTabs from "../../../../Components/Common/Tabs/StepperTabs/StepperTabs";
import Select from "react-select";
import { useDispatch } from "react-redux";
import rootReducer from "../../../../store";
import { setProductVariantModalState } from "../../../../slices/orders/orderSlice";
import {
  getAllProductVariant,
  getDependentAttributeValues,
  getChildAttributeValue,
} from "../OrderService";
import { formatAmount, numberToWords } from "../../../../Utils/CommonUtils";
import OemModal from "./OemModal";
import { useParams } from "react-router-dom";
import { add } from "@dnd-kit/utilities";
import moment from "moment";
import InformationLineIcon from "remixicon-react/InformationLineIcon";
import { showToast } from "../../../../common/Toaster/Toaster";

const ProductAttributeModalEdit = ({ show, onHide }) => {
  // alert("product attribute edit modal");
  const dispatch = useDispatch();
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData,
  );
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState,
  );
  const qualification = useSelector((state) => state.order.qualification);
  const productVariant = useSelector(
    (state) => state.order.selectedOrders.productVariant,
  );
  const [productTabs, setProductTabs] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const formState = useSelector((state) => state.common.formRendererState);
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData,
  );
  const productAttributesList = productAttributeData?.flatMap(
    (product) => product.product_attributes_list || [],
  );
  const [displayedValues, setDisplayedValues] = useState({});
  const [selectedOem, setSelectedOem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();
  const [showQuoteDetails, setShowQuoteDetails] = useState(false);
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  // idle | loading | valid | invalid | error
  const [doctorCategoryCheck, setDoctorCategoryCheck] = useState("idle");
  const doctorCategoryRequestRef = useRef(0);

  const isPaymentDone =
    detailsData?.status === "PAYMENT_SUCCESS" ||
    detailsData?.status === "COMPLETED";

  // Fresh orders compare against variant_json, renewals against current_variant_json
  const getOrderDoctorCategory = (entityid) => {
    const rawJson =
      detailsData?.order_type === "RENEWAL"
        ? detailsData?.current_variant_json
        : detailsData?.variant_json;
    if (!rawJson) return null;

    let variantJson = rawJson;
    if (typeof rawJson === "string") {
      try {
        variantJson = JSON.parse(rawJson);
      } catch (e) {
        return null;
      }
    }

    const doctorCategory =
      variantJson?.[entityid]?.doctor_category ??
      Object.values(variantJson || {}).find(
        (obj) => obj && typeof obj === "object" && obj.doctor_category,
      )?.doctor_category;
    return doctorCategory ?? null;
  };

  const qualificationTab = productTabs.find((tab) =>
    tab.attributes?.some((a) => a.attribute_key === "qualification"),
  );
  const selectedQualification = qualificationTab
    ? productVariantModalState?.[qualificationTab.entityid]?.qualification
    : undefined;
  const orderDoctorCategory = qualificationTab
    ? getOrderDoctorCategory(qualificationTab.entityid)
    : null;
  const requiresDoctorCategoryCheck =
    show && isPaymentDone && !!qualificationTab && !!orderDoctorCategory;
  const isDoctorCategoryBlocked =
    requiresDoctorCategoryCheck && doctorCategoryCheck !== "valid";

  useEffect(() => {
    if (productAttributeData && productAttributeData.length > 0) {
      const tabs = productAttributeData.map((child) => ({
        name: child.name,
        entityid: child.entityid,
        attributes: child.product_attributes_list?.map((attribute) => ({
          label: attribute.name,
          lov: attribute.product_attribute_lov || [],
          element_type: attribute.element_type,
          attribute_key: attribute.attribute_key,
          ...(attribute.format_type && { format_type: attribute.format_type }),
          isDisabled: attribute.is_disabled,
          isRequired: attribute.required,
          min: attribute.filter_min,
          max: attribute.filter_max,
          parent_key: attribute.parent_key || null,
          parent_attribute_key: attribute.parent_attribute_key || null,
          parent_attribute_id: attribute.parent_attribute_id || null,
          maxLength: attribute.max_length,
          default_values: attribute.default_values,
          entityid: attribute.entityid,
          description: attribute.description,
        })),
        addons: child.product_addon_list?.map((addon) => ({
          label: addon.label,
          name: addon.name || "",
          element_type: addon.element_type,
          lov: addon.product_addon_lov || [],
          entityid: addon.entityid,
          ...(addon.format_type && { format_type: addon.format_type }),
          min: addon.min_value,
          max: addon.max_value,
          default_value: addon.default_value,
          isDisabled: addon.is_disabled,
          maxLength: addon.max_length,
        })),
      }));
      setProductTabs(tabs);
    }
  }, [productAttributeData]);

  useEffect(() => {
    if (show) {
      setCurrentStep(0);
    }
  }, [show]);

  useEffect(() => {
    if (productTabs.length > 0) {
      productTabs.forEach((tab) => {
        tab.attributes?.forEach((attribute) => {
          if (
            attribute.element_type === "dropdown" &&
            attribute.default_values !== undefined &&
            attribute.default_values !== null &&
            attribute.default_values !== ""
          ) {
            // Set value in form
            // setValue(attribute.attribute_key, attribute.default_values);

            // Store value using your internal handler
            handleChange(
              tab.entityid,
              attribute.attribute_key,
              attribute.default_values,
            );
          }
        });
      });
    }
  }, [productTabs, show]);

  useEffect(() => {
    if (productTabs.length > 0) {
      productTabs.forEach((tab) => {
        tab.addons?.forEach((addon) => {
          if (addon.element_type === "checkbox") {
            const defaultValue = addon.default_value === "yes" ? "yes" : "no";

            handleChange(tab.entityid, addon.name, defaultValue);
          }
        });
      });
    }
  }, [productTabs]);

  const handleChange = (entityid, attributeKey, value, showValue = null) => {
    const currentState = rootReducer.getState().order.productVariantModalState;
    // let updatedState = {
    //   ...currentState,
    //   [entityid]: {
    //     ...currentState[entityid],
    //     [attributeKey]: value,
    //   },
    // };
    let updatedEntity = {
      ...currentState[entityid],
    };
    updatedEntity[attributeKey] = value;

    // Handle initialization/resizing for additional_variants
    const tab = productTabs.find((t) => t.entityid === entityid);
    const variantField = tab?.attributes?.find(
      (a) =>
        a.element_type === "additional_variants" &&
        a.parent_key === attributeKey,
    );

    if (variantField) {
      const count = parseInt(value) || 0;
      const currentArray = updatedEntity[variantField.attribute_key] || [];

      if (count === 0) {
        delete updatedEntity[variantField.attribute_key];
      } else {
        // Resize array and keep existing data
        const newArray = Array.from(
          { length: count },
          (_, i) => currentArray[i] || {},
        );
        updatedEntity[variantField.attribute_key] = newArray;
      }
    }

    // Clear dependent attributes that are not valid anymore
    const entityAttributes =
      productTabs.find((tab) => tab.entityid === entityid)?.attributes || [];

    entityAttributes.forEach((attr) => {
      const isDependent =
        attr.parent_key === attributeKey ||
        attr.parent_attribute_key === attributeKey ||
        (attr.parent_attribute_id && String(attr.parent_attribute_id) === String(attributeKey));

      if (isDependent) {
        const parentValueNum = parseInt(value) || 0;
        const shouldShow =
          (attributeKey === "ownership" && value !== "Rented") ||
          !attributeKey ||
          String(value).toLowerCase() === "yes" ||
          parentValueNum > 0;

        if (!shouldShow && updatedEntity[attr.attribute_key]) {
          delete updatedEntity[attr.attribute_key];
        }
      }
    });

    let updatedState = {
      ...currentState,
      [entityid]: updatedEntity,
    };

    setDisplayedValues((prev) => ({
      ...prev,
      [attributeKey]: showValue || value, // Show label if available
    }));
    handleDependentValue(entityid, attributeKey, value);

    const currentTabIndex = productTabs.findIndex(
      (tab) => tab.entityid === entityid,
    );

    for (let i = currentTabIndex + 1; i < productTabs.length; i++) {
      const nextTab = productTabs[i];
      const hasAttribute = nextTab.attributes.some(
        (attr) => attr.attribute_key === attributeKey,
      );

      if (hasAttribute) {
        updatedState = {
          ...updatedState,
          [nextTab.entityid]: {
            ...updatedState[nextTab.entityid],
            [attributeKey]: value,
          },
        };
      }
    }
    dispatch(setProductVariantModalState(updatedState));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`${entityid}.${attributeKey}`]; // Remove the specific field error
      return updatedErrors;
    });
  };

  const handleArrayChange = (entityid, attributeKey, index, subKey, value) => {
    const currentState = rootReducer.getState().order.productVariantModalState;
    const entityState = { ...currentState[entityid] };
    const arrayData = [...(entityState[attributeKey] || [])];

    arrayData[index] = {
      ...arrayData[index],
      [subKey]: value,
    };

    const updatedState = {
      ...currentState,
      [entityid]: {
        ...entityState,
        [attributeKey]: arrayData,
      },
    };
    dispatch(setProductVariantModalState(updatedState));
  };
  // const handleDependentValue = (entityid, key, value) => {
  //   const productId = detailsData?.productid || formState?.product_id;

  //   if (key === "qualification") {
  //     getDependentAttributeValues(productId, key, value).then((response) => {
  //       console.log("Dependent API Response:", response);

  //       if (response) {
  //         handleChange(
  //           entityid,
  //           "doctor_category",
  //           response.default_values,
  //           response.attribute_lov_label
  //         );
  //       }
  //     });
  //   }
  //   if (key === "pincode") {
  //     getDependentAttributeValues(productId, key, value).then((response) => {
  //       console.log("Dependent API Response:", response);

  //       if (response) {
  //         handleChange(
  //           entityid,
  //           "eq_zone",
  //           response.default_values,
  //           response.attribute_lov_label
  //         );
  //       }
  //     });
  //   }
  // };

  // const handleGetCode = () => {
  //   const { oem, finalPremium, ...filteredState } = productVariantModalState;
  //   getAllProductVariant(
  //     formState.product_id,
  //     filteredState
  //     // onHide
  //   );
  //   setShowQuoteDetails(true);
  // };
  // useEffect(() => {
  //   if (show && qualification) {
  //     handleDependentValue(
  //       detailsData?.productid || formState?.product_id,
  //       "qualification",
  //       qualification,
  //     );
  //   }
  // }, [show, qualification]);
  const handleDependentValue = (entityid, key, value) => {
    const productId = detailsData?.productid || formState?.product_id;

    if (!show) return;
    if (value === null || value === undefined || value === "") return;

    // Convert boolean true to string "true" if necessary, or ensure consistency
    const processedValue = (typeof value === 'boolean') ? String(value) : value;

    if (key === "qualification") {
      getDependentAttributeValues(productId, key, value).then((response) => {
        console.log("Dependent API Response:", response);

        if (response) {
          handleChange(
            entityid,
            "doctor_category",
            response.default_values,
            response.attribute_lov_label,
          );
        }
      });
    }

    if (key === "pincode") {
      getDependentAttributeValues(productId, key, value).then((response) => {
        console.log("Dependent API Response:", response);

        if (response) {
          handleChange(
            entityid,
            "eq_zone",
            response.default_values,
            response.attribute_lov_label,
          );
        }
      });
    }

    console.log(`handleDependentValue called: key=${key}, value=${value}`);

    productTabs.forEach((tab) => {
      tab.attributes?.forEach((attr) => {
        const isDependent = 
          attr.parent_attribute_key === key || 
          attr.parent_key === key ||
          (attr.parent_attribute_id && String(attr.parent_attribute_id) === String(key));

        if (isDependent) {
          console.log(`Found dependent attribute: ${attr.attribute_key} (ID: ${attr.entityid}) in tab ${tab.name}`);
          getChildAttributeValue(attr.entityid, processedValue).then((res) => {
            console.log(`getChildAttributeValue API response for ${attr.attribute_key}:`, res);
            if (res) {
              // Check if response has dependent_attribute_value or is the value itself
              const dependentValue = 
                res.attribute_value !== undefined 
                  ? res.attribute_value 
                  : (typeof res === 'string' || typeof res === 'number') ? res : null;
              
              if (dependentValue !== null && dependentValue !== undefined) {
                  handleChange(
                    tab.entityid,
                    attr.attribute_key,
                    dependentValue
                  );
              }
            }
          }).catch(err => {
            console.error(`Error in getChildAttributeValue for ${attr.attribute_key}:`, err);
          });
        }
      });
    });
  };

  useEffect(() => {
    if (!requiresDoctorCategoryCheck) {
      setDoctorCategoryCheck("idle");
      return;
    }
    if (
      selectedQualification === undefined ||
      selectedQualification === null ||
      selectedQualification === ""
    ) {
      setDoctorCategoryCheck("invalid");
      return;
    }

    const requestId = ++doctorCategoryRequestRef.current;
    const productId = detailsData?.productid || formState?.product_id;
    const normalize = (v) =>
      String(v ?? "")
        .trim()
        .toLowerCase();

    setDoctorCategoryCheck("loading");
    getDependentAttributeValues(productId, "qualification", selectedQualification)
      .then((response) => {
        // Ignore responses from an older qualification selection
        if (requestId !== doctorCategoryRequestRef.current) return;

        if (!response) {
          setDoctorCategoryCheck("error");
          showToast("Unable to validate doctor category.", "error");
          return;
        }

        const expected = normalize(orderDoctorCategory);
        const isMatch =
          normalize(response.attribute_lov_label) === expected ||
          normalize(response.default_values) === expected;

        if (isMatch) {
          setDoctorCategoryCheck("valid");
        } else {
          setDoctorCategoryCheck("invalid");
          showToast("Please select the correct doctor category.", "error");
        }
      })
      .catch(() => {
        if (requestId !== doctorCategoryRequestRef.current) return;
        setDoctorCategoryCheck("error");
        showToast("Unable to validate doctor category.", "error");
      });
  }, [requiresDoctorCategoryCheck, selectedQualification, orderDoctorCategory]);

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleContinue = () => {
    if (!validateFields()) {
      return;
    }
    if (currentStep < productTabs.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleGetCode = () => {
    if (!validateFields()) {
      return;
    }

    const { oem, finalPremium, ...filteredState } = productVariantModalState;

    getAllProductVariant(formState.product_id, filteredState);

    setShowQuoteDetails(true);
    setIsFirstOpen(true);
  };

  const handleOemChange = (code, attributeMap, finalPremium, coverAmount) => {
    const selectedOption = {
      value: code,
      variant_json: attributeMap,
      finalPremium: finalPremium,
      coverAmount: coverAmount,
    };
    setSelectedOem(selectedOption);
    dispatch(
      setProductVariantModalState({
        ...productVariantModalState,
        oem: code,
        variant: selectedOption.variant_json,
        finalPremium: selectedOption.finalPremium,
        coverAmount: selectedOption.coverAmount,
      }),
    );
  };

  const handleSave = () => {
    onHide();
    setIsFirstOpen(false);
  };

  const validateFields = () => {
    const newErrors = {};

    const currentTab = productTabs[currentStep];
    const entityState = productVariantModalState[currentTab.entityid] || {};
    const ownershipValue = entityState.ownership;

    if (currentTab?.attributes) {
      currentTab.attributes.forEach((attribute) => {
        const fieldKey = attribute.attribute_key;
        const parentValue = entityState[attribute.parent_key];
        const parentValueNum = parseInt(parentValue) || 0;
        const shouldShow =
          (attribute.parent_key === "ownership" &&
            ownershipValue !== "Rented") ||
          !attribute.parent_key ||
          String(parentValue).toLowerCase() === "yes" ||
          parentValueNum > 0;

        if (!shouldShow) return;

        if (fieldKey === "building_cover" && ownershipValue === "Rented")
          return;

        if (attribute.element_type === "additional_variants") {
          const count = parentValueNum;
          const arrayData = entityState[fieldKey] || [];

          // Validate all children inside the array
          const subFields = currentTab.attributes.filter(
            (a) =>
              a.element_type !== "additional_variants" &&
              a.attribute_key !== attribute.parent_key,
          );

          for (let i = 0; i < count; i++) {
            subFields.forEach((sub) => {
              const subValue = arrayData[i]?.[sub.attribute_key];
              const errorKey = `${currentTab.entityid}.${fieldKey}.${i}.${sub.attribute_key}`;

              if (
                sub.isRequired &&
                (subValue === undefined || subValue === "")
              ) {
                newErrors[errorKey] = `Member ${i + 1} ${sub.label} is required.`;
              } else if (sub.element_type === "date" && subValue) {
                const dateVal = moment(subValue);
                if (dateVal.isValid()) {
                  const age = moment().diff(dateVal, "years");
                  if (sub.min !== undefined && age < sub.min) {
                    newErrors[errorKey] = `Age must be at least ${sub.min} years.`;
                  } else if (sub.max !== undefined && age > sub.max) {
                    newErrors[errorKey] = `Age must be at most ${sub.max} years.`;
                  }
                }
              }
            });
          }
          return;
        }

        const value = entityState[fieldKey];
        if (attribute.isRequired && (value === undefined || value === "")) {
          newErrors[`${currentTab.entityid}.${fieldKey}`] =
            "This field is required.";
          return;
        }

        if (
          (attribute.element_type === "number" ||
            attribute.element_type === "range") &&
          value !== undefined &&
          value !== ""
        ) {
          const numericValue = Number(value);
          if (attribute.min !== undefined && numericValue < attribute.min) {
            newErrors[`${currentTab.entityid}.${fieldKey}`] =
              `Minimum value is ${attribute.min}.`;
          } else if (
            attribute.max !== undefined &&
            numericValue > attribute.max
          ) {
            newErrors[`${currentTab.entityid}.${fieldKey}`] =
              `Maximum value is ${attribute.max}.`;
          }
        }
      });
    }

    if (currentTab?.addons) {
      currentTab.addons.forEach((addon) => {
        const addonKey = addon.name;
        const value = entityState[addonKey];

        if (addon.isRequired && (value === undefined || value === "")) {
          newErrors[`${currentTab.entityid}.${addonKey}`] =
            "This field is required.";
          return;
        }

        if (
          (addon.element_type === "number" || addon.element_type === "range") &&
          value !== undefined &&
          value !== ""
        ) {
          const numericValue = Number(value);
          if (addon.min !== undefined && numericValue < addon.min) {
            newErrors[`${currentTab.entityid}.${addonKey}`] =
              `Minimum value is ${addon.min}.`;
          } else if (addon.max !== undefined && numericValue > addon.max) {
            newErrors[`${currentTab.entityid}.${addonKey}`] =
              `Maximum value is ${addon.max}.`;
          }
        }
      });
    }

    setErrors(newErrors);
    console.log("Validation Errors:", newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const getCurrentTabDetails = () => {
    const currentTab = productTabs[currentStep];

    if (!currentTab) return <div>Loading...</div>;

    const isTwoColumnLayout =
      currentTab.attributes.length > 3 || currentTab.addons.length > 3;

    const chunkArray = (array, size) => {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        const chunk = array.slice(i, i + size);
        if (chunk.length > 0) {
          result.push(chunk);
        }
      }
      return result;
    };

    const renderAttributes = (attributes) => {
      if (!attributes || attributes.length === 0) return null;
      const groupedAttributes = chunkArray(attributes, 2); // Group into pairs

      const ownershipValue =
        productVariantModalState[currentTab.entityid]?.ownership;

      // After payment, if the tab has a qualification field, only qualification stays editable
      const isPaid =
        isPaymentDone || Boolean(detailsData?.Policy_detail?.length);
      const hasQualification = attributes.some(
        (a) => a.attribute_key === "qualification",
      );
      const isLocked = (attr) =>
        isPaid && hasQualification && attr.attribute_key !== "qualification";
      return groupedAttributes.map((group, rowIndex) => (
        <Row key={rowIndex} className="attribute-group">
          {group.map((attribute, index) => {
            // if (
            //   attribute.attribute_key === "building_cover" &&
            //   ownershipValue === "Rented"
            // ) {
            //   return null;
            // }

            const parentValue =
              productVariantModalState[currentTab.entityid]?.[
                attribute.parent_key
              ];

            const parentValueNum = parseInt(parentValue) || 0;
            const shouldShow =
              (attribute.parent_key === "ownership" &&
                parentValue !== "Rented") ||
              !attribute.parent_key ||
              String(parentValue).toLowerCase() === "yes" ||
              parentValueNum > 0;

            if (!shouldShow) return null;

            if (attribute.element_type === "additional_variants") {
              const count = parseInt(parentValue) || 0;
              const arrayData =
                productVariantModalState[currentTab.entityid]?.[
                  attribute.attribute_key
                ] || [];

              const subFields = attributes.filter(
                (a) =>
                  a.element_type !== "additional_variants" &&
                  a.attribute_key !== attribute.parent_key,
              );

              return (
                <React.Fragment key={index}>
                  {Array.from({ length: count }).map((_, idx) =>
                    subFields.map((subAttr, sIdx) => (
                      <Col
                        md={6}
                        key={`${idx}-${sIdx}`}
                        style={
                          subAttr.element_type === "date"
                            ? { marginTop: "10px" }
                            : {}
                        }
                      >
                        <Form.Label>
                          Member {idx + 1} {subAttr.label}
                          {subAttr.isRequired === 1 && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>
                        {subAttr.element_type === "dropdown" ? (
                          <>
                            <Select
                              options={subAttr.lov.map((o) => ({
                                value: o.attribute_value,
                                label: o.name,
                              }))}
                              isClearable={true}
                              value={
                                arrayData[idx]?.[subAttr.attribute_key]
                                  ? {
                                      value:
                                        arrayData[idx][subAttr.attribute_key],
                                      label:
                                        subAttr.lov.find(
                                          (o) =>
                                            o.attribute_value ===
                                            arrayData[idx][
                                              subAttr.attribute_key
                                            ],
                                        )?.name || "",
                                    }
                                  : null
                              }
                              onChange={(opt) =>
                                handleArrayChange(
                                  currentTab.entityid,
                                  attribute.attribute_key,
                                  idx,
                                  subAttr.attribute_key,
                                  opt?.value,
                                )
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1055,
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  color: state.isDisabled
                                    ? "#878a99"
                                    : base.color,
                                  display: state.isDisabled ? "none" : "flex",
                                }),
                                indicatorSeparator: (base, state) => ({
                                  ...base,
                                  display: state.isDisabled ? "none" : "flex",
                                  backgroundColor: state.isDisabled
                                    ? "#878a99"
                                    : base.backgroundColor,
                                }),
                              }}
                            />
                            {(() => {
                              const selectedOption = attribute.lov?.find(
                                (o) => o.attribute_value === storedRawValue,
                              );
                              return (
                                selectedOption?.description && (
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      // color: "#6c757d",
                                      marginTop: "4px",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: selectedOption.description,
                                    }}
                                  />
                                )
                              );
                            })()}
                          </>
                        ) : subAttr.element_type === "text" ? (
                          <Form.Control
                            type="text"
                            placeholder={"Enter " + subAttr.label}
                            value={
                              arrayData[idx]?.[subAttr.attribute_key] || ""
                            }
                            onChange={(e) =>
                              handleArrayChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                idx,
                                subAttr.attribute_key,
                                e.target.value,
                              )
                            }
                          />
                        ) : subAttr.element_type === "date" ? (
                          <>
                            <Form.Control
                              type="date"
                              className="form-control"
                              placeholder={"Select " + subAttr.label}
                              value={
                                arrayData[idx]?.[subAttr.attribute_key] || ""
                              }
                              onChange={(e) => {
                                handleArrayChange(
                                  currentTab.entityid,
                                  attribute.attribute_key,
                                  idx,
                                  subAttr.attribute_key,
                                  e.target.value
                                );
                              }}
                              isInvalid={
                                !!errors[
                                  `${currentTab.entityid}.${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`
                                ]
                              }
                            />
                            {errors[
                              `${currentTab.entityid}.${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`
                            ] && (
                              <div className="text-danger">
                                {
                                  errors[
                                    `${currentTab.entityid}.${attribute.attribute_key}.${idx}.${subAttr.attribute_key}`
                                  ]
                                }
                              </div>
                            )}
                          </>
                        ) : null}
                      </Col>
                    )),
                  )}
                </React.Fragment>
              );
            }

            return (
              <Col md={6} key={index}>
                <Form.Label htmlFor={`dropdown-${index}`}>
                  {attribute.label}
                  {attribute.isRequired === 1 && (
                    <span className="text-danger">*</span>
                  )}
                  {attribute.description && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{attribute.description}</Tooltip>}
                    >
                      <span
                        className="ms-1 align-middle text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        <InformationLineIcon size={16} />
                      </span>
                    </OverlayTrigger>
                  )}
                </Form.Label>
                {attribute.element_type === "dropdown" ||
                attribute.element_type === "range" ? (
                  <>
                    <Select
                      key={attribute.attribute_key}
                      name={attribute.attribute_key}
                      isClearable={true}
                      options={attribute.lov.map((option) => ({
                        value: option.attribute_value,
                        label: option.name,
                      }))}
                      value={
                        productVariantModalState[currentTab.entityid]?.[
                          attribute.attribute_key || attribute.default_values
                        ]
                          ? {
                              value:
                                productVariantModalState[currentTab.entityid]?.[
                                  attribute.attribute_key ||
                                    attribute.default_values
                                ],
                              label:
                                attribute.lov.find(
                                  (option) =>
                                    option.attribute_value ===
                                    productVariantModalState[
                                      currentTab.entityid
                                    ]?.[attribute.attribute_key],
                                )?.name || "",
                            }
                          : null
                      }
                      isDisabled={
                        attribute.isDisabled === 1 || isLocked(attribute)
                      }
                      label={attribute.label}
                      onChange={(selectedOption) => {
                        handleChange(
                          currentTab.entityid,
                          attribute.attribute_key,
                          selectedOption?.value,
                        );
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 1055 }),
                        dropdownIndicator: (base, state) => ({
                          ...base,
                          color: state.isDisabled ? "#878a99" : base.color,
                          display: state.isDisabled ? "none" : "flex",
                        }),
                        indicatorSeparator: (base, state) => ({
                          ...base,
                          display: state.isDisabled ? "none" : "flex",
                          backgroundColor: state.isDisabled
                            ? "#878a99"
                            : base.backgroundColor,
                        }),
                      }}
                    />
                    {(() => {
                      const selectedValue =
                        productVariantModalState[currentTab.entityid]?.[
                          attribute.attribute_key
                        ];
                      const selectedOption = attribute.lov?.find(
                        (o) => o.attribute_value === selectedValue,
                      );

                      return (
                        selectedOption?.description && (
                          <div
                            style={{
                              fontSize: "12px",
                              // color: "#6c757d",
                              marginTop: "4px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: selectedOption.description,
                            }}
                          />
                        )
                      );
                    })()}
                    {errors[
                      `${currentTab.entityid}.${attribute.attribute_key}`
                    ] && (
                      <div className="text-danger">
                        {
                          errors[
                            `${currentTab.entityid}.${attribute.attribute_key}`
                          ]
                        }
                      </div>
                    )}
                  </>
                ) : attribute.element_type === "number" ||
                  attribute.element_type === "range_number" ? (
                  <>
                    <Form.Control
                      type="tel"
                      key={attribute.attribute_key}
                      name={attribute.attribute_key}
                      min={attribute.min}
                      max={attribute.max}
                      placeholder={`Enter ${attribute.label}`}
                      disabled={isLocked(attribute)}
                      value={
                        productVariantModalState[currentTab.entityid]?.[
                          attribute.attribute_key
                        ] || ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        handleChange(
                          currentTab.entityid,
                          // "product_attribute_list",
                          attribute.attribute_key,
                          value,
                        );
                      }}
                      minLength={attribute?.minLength}
                      maxLength={attribute?.maxLength}
                      pattern="[0-9]*"
                      isInvalid={!!errors[attribute.attribute_key]}
                    />

                    {attribute.element_type === "number" &&
                      attribute.format_type === "Amount" && (
                        <div
                          style={{
                            color: "gray",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {numberToWords(
                            productVariantModalState[currentTab.entityid]?.[
                              attribute.attribute_key
                            ] || "",
                          )}
                        </div>
                      )}
                    {errors[
                      `${currentTab.entityid}.${attribute.attribute_key}`
                    ] && (
                      <div className="text-danger">
                        {
                          errors[
                            `${currentTab.entityid}.${attribute.attribute_key}`
                          ]
                        }
                      </div>
                    )}
                  </>
                ) : attribute.element_type === "select" ? (
                  <div className="radio-group-container">
                    <div className="radio-group">
                      {attribute.lov.map((option, optionIndex) => (
                        <div
                          className="radio-wrapper horizontal"
                          key={optionIndex}
                        >
                          {/* <Radio
                          key={`${attribute.attribute_key}`}
                          name={`${attribute.attribute_key}`}
                          control={control}
                          label={option.name}
                          value={option.value}
                          errors={errors}
                          className="radio-style"
                          rules={{
                            required: "Please select an option",
                          }}
                        /> */}
                          {/* <Form.Check
                          type="radio"
                          key={`${attribute.attribute_key}`}
                          name={`${attribute.attribute_key}`}
                          label={option.name}
                          // value={option.value}
                          value={
                            productVariantModalState[currentTab.entityid]?.[
                              option.value
                            ] || ""
                          }
                        /> */}
                          <Form.Check
                            key={index}
                            type="radio"
                            name={attribute.attribute_key}
                            label={option.name}
                            value={option.attribute_value}
                            disabled={isLocked(attribute)}
                            checked={
                              productVariantModalState[currentTab.entityid]?.[
                                attribute.attribute_key
                              ] === option.attribute_value
                            }
                            onChange={(e) => {
                              handleChange(
                                currentTab.entityid,
                                attribute.attribute_key,
                                e.target.value,
                              );
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    {errors[
                      `${currentTab.entityid}.${attribute.attribute_key}`
                    ] && (
                      <div className="text-danger">
                        {
                          errors[
                            `${currentTab.entityid}.${attribute.attribute_key}`
                          ]
                        }
                      </div>
                    )}
                  </div>
                ) : attribute.element_type === "badge" ||
                  attribute.element_type === "text" ? (
                  <>
                    <Form.Control
                      type="text"
                      key={attribute.attribute_key}
                      name={attribute.attribute_key}
                      placeholder="Enter"
                      value={
                        displayedValues[attribute.attribute_key] ||
                        productVariantModalState[currentTab.entityid]?.[
                          attribute.attribute_key
                        ]
                      } // Show label
                      disabled={
                        attribute.attribute_key === "doctor_category" ||
                        isLocked(attribute)
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        handleChange(
                          currentTab.entityid,
                          attribute.attribute_key,
                          value,
                        );
                      }}
                      isInvalid={!!errors[attribute.attribute_key]}
                    />
                    {errors[
                      `${currentTab.entityid}.${attribute.attribute_key}`
                    ] && (
                      <div className="text-danger">
                        {
                          errors[
                            `${currentTab.entityid}.${attribute.attribute_key}`
                          ]
                        }
                      </div>
                    )}
                  </>
                ) : null}
              </Col>
            );
          })}
        </Row>
      ));
    };

    const renderAddOns = (addOns) => {
      if (!addOns || addOns.length === 0) return null;
      const groupedAddOns = chunkArray(addOns, 2);
      // Group into pairs

      return groupedAddOns.map((group, rowIndex) => (
        <Row key={rowIndex} className="attribute-group">
          {group?.map((addon, index) => (
            <Col md={6} key={index}>
              {addon.element_type === "checkbox" ? (
                <>
                  <Form.Check
                    type="checkbox"
                    id={`addon-${index}`}
                    label={addon.label}
                    value={addon.name} // Ensure this is a simple string
                    // checked={
                    //   productVariantModalState[currentTab.entityid]?.[
                    //     addon.name
                    //   ] === "yes"
                    // }
                    // checked={
                    //   productVariantModalState[currentTab.entityid]?.[addon.name] === "yes" ||
                    //   (!productVariantModalState[currentTab.entityid]?.[addon.name] &&
                    //     addon.default_value === "yes")
                    // }
                    checked={
                      productVariantModalState[currentTab.entityid]?.[
                        addon.name
                      ] === "yes" ||
                      (!productVariantModalState[currentTab.entityid]?.[
                        addon.name
                      ] &&
                        addon.default_value === "yes")
                    }
                    disabled={addon.isDisabled === 1}
                    onChange={(e) => {
                      const isChecked = e.target.checked; // Boolean
                      const attributeKey = addon.name; // Ensure it's a string key

                      handleChange(
                        currentTab.entityid,
                        attributeKey,
                        isChecked ? "yes" : "no",
                      );
                    }}
                  />
                  {errors[`${currentTab.entityid}.${addon.name}`] && (
                    <div className="text-danger">
                      {errors[`${currentTab.entityid}.${addon.name}`]}
                    </div>
                  )}
                </>
              ) : addon.element_type === "select" ? (
                <div className="radio-group-container">
                  <label className="radio-group-label">{addon.label}</label>
                  <div className="radio-group">
                    {addon.lov.map((option, optionIndex) => (
                      <div
                        className="radio-wrapper horizontal"
                        key={optionIndex}
                      >
                        <Radio
                          key={`addon_${index}`}
                          name={`addon_${index}`}
                          control={control}
                          label={option.name}
                          value={option.value}
                          errors={errors}
                          className="radio-style"
                          // rules={{
                          //   required: "Please select an option",
                          // }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  <label className="radio-group-label">{addon.label}</label>
                  <>
                    <Form.Control
                      type="tel"
                      key={addon.name}
                      name={addon.name}
                      label={addon.label}
                      placeholder={`Enter ${addon.label}`}
                      value={
                        productVariantModalState[currentTab.entityid]?.[
                          addon.name
                        ] || ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        handleChange(
                          currentTab.entityid,
                          // "product_attribute_list",
                          addon.name,
                          value,
                        );
                      }}
                      minLength={addon?.minLength}
                      maxLength={addon?.maxLength}
                      pattern="[0-9]*"
                      isInvalid={!!errors[addon.name]}
                    />
                    {addon.format_type === "Amount" && (
                      <div
                        style={{
                          color: "gray",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {numberToWords(
                          productVariantModalState[currentTab.entityid]?.[
                            addon.name
                          ] || "",
                        )}
                      </div>
                    )}

                    {errors[`${currentTab.entityid}.${addon.name}`] && (
                      <div className="text-danger">
                        {errors[`${currentTab.entityid}.${addon.name}`]}
                      </div>
                    )}
                  </>
                </div>
              )}
            </Col>
          ))}
        </Row>
      ));
    };

    return (
      <div>
        <div className="cover-details">
          <div
            className={`form--content--wrapper ${
              isTwoColumnLayout ? "two-column" : "single-column"
            }`}
          >
            <Row>
              <Col>{renderAttributes(currentTab.attributes)}</Col>
            </Row>

            {currentTab.addons && currentTab.addons.length > 0 && (
              <>
                <div className="addons-header">Add Ons</div>
                <Row>
                  <Col>{renderAddOns(currentTab.addons)}</Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={onHide}
      size="lg"
    >
      <Form className="attributes-container">
        <Modal.Header className="p-3 bg-info-subtle" closeButton>
          <strong>Attributes</strong>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="step-tabs-indicator">
            <StepperTabs
              steps={productTabs}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              direction="horizontal"
              // enableClick={true}
            />
          </div>
          <div className="tabs-details">{getCurrentTabDetails()}</div>
          <div
            className="attributes-button-container"
            // style={{ display: "flex", justifyContent: "space-between" }}
          >
            {currentStep !== 0 ? (
              <Button className="previous" type="button" onClick={handleBack}>
                Back
              </Button>
            ) : (
              <div />
            )}

            <Button
              type="button"
              className="next"
              disabled={isDoctorCategoryBlocked}
              onClick={
                currentStep === productTabs.length - 1
                  ? handleGetCode
                  : handleContinue
              }
              style={{ marginLeft: currentStep === 0 ? "auto" : "0" }} // Align right on first tab
            >
              {currentStep === productTabs.length - 1
                ? "Get Quote"
                : "Continue"}
            </Button>
          </div>

          {showQuoteDetails && isFirstOpen && (
            <div className="mt-2">
              <div className="attributes-header">Insurance Company</div>
              {productVariant.content?.map((product, index) => {
                return (
                  <div key={index} className="mb-3">
                    {(() => {
                      const insurers = product.product_variants
                        .map((v) => v.pspOem?.name)
                        .filter(
                          (name, i, arr) => name && arr.indexOf(name) === i,
                        );

                      const insurerLabel = insurers.join(" & ");
                      const firstOemCode = product.product_variants.find(
                        (v) => v.pspOem?.code,
                      )?.pspOem?.code;

                      if (!insurerLabel) return null;

                      return (
                        <div className="d-flex gap-5">
                          <Form.Check
                            type="radio"
                            id={`oem-option-${index}`}
                            label={insurerLabel}
                            value={firstOemCode}
                            checked={
                              productVariantModalState &&
                              productVariantModalState.oem === firstOemCode
                            }
                            onChange={() =>
                              handleOemChange(
                                firstOemCode,
                                product.attribute_map,
                                product.final_premium,
                                product.attribute_map.cover,
                              )
                            }
                          />
                          <p className="mb-0">
                            Premium Amount -{" "}
                            {formatAmount(
                              product.final_premium,
                              null,
                              null,
                              "lakh",
                            )}
                          </p>
                        </div>
                      );
                    })()}
                  </div>
                );
              })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {productVariantModalState.variant && (
            <Button type="button" onClick={handleSave} disabled={!selectedOem}>
              {id ? "Save" : "Save"}
            </Button>
          )}
        </Modal.Footer>
      </Form>
      <OemModal show={showModal} onHide={() => setShowModal(false)} />
    </Modal>
  );
};

export default ProductAttributeModalEdit;
